/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const brandingFontDataSchema = z.object({
	title: z.string().nullable(),
	body: z.string().nullable(),
})

export type BrandingFontDataSchema = z.infer<typeof brandingFontDataSchema>
